exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 580px) {\n.review-rating .vue-star-rating-star {\n    margin: 0 !important;\n}\n}", ""]);

// exports
